<template>
  <v-card class="hint_tag" transition="slide-y-transition" v-show="visible">
    <v-card-title>
      <span
        >This DEMO version only shows the value of logP, Mutagenicity and
        Physicochemical</span
      >
    </v-card-title>
    <v-card-text
      >If you would like to know more about the prediction results, you can try
      our
      <a
        href="https://virtualman-predictor.web.app/"
        title="FREE trial version of ADMET/PK prediction"
        target="_blank"
        >FREE trial version of ADMET/PK prediction</a
      >
      or contact us at contact@virtualman.ai.<br><br>
      <a
        href="https://virtualman.ai"
        title="VIRTUALMAN"
        target="_blank"
        class="imglink"
        ><img src="/link_v.png" alt="" height="18"></a
      >
      <a
        href="https://www.youtube.com/channel/UC5uqV9IZJaut_WzqweynCVw"
        title="Youtube"
        target="_blank"
        class="imglink"
        ><img src="/link_y.png" alt="" height="21"></a
      >
      <a
        href="https://virtualman-predictor.web.app"
        title="FREE trial version of ADMET/PK prediction"
        target="_blank"
        class="imglink"
        ><img src="/link_p.png" alt="" height="29"></a
      ></v-card-text
    >
    <v-btn color="#FFFFFF" @click="close" class="btn_close" depressed>
      <v-icon size="20" color="#717171">mdi-close</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "HintTag",
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
  },
};
</script>
